// Function to get URL parameters
function getUrlParameters() {
  const searchParams = new URLSearchParams(window.location.search);

  const utmCampaign = searchParams.get("utm_campaign");
  const utmSource = searchParams.get("utm_source");
  const utmMedium = searchParams.get("utm_medium");
  const utmTerm = searchParams.get("utm_term");
  const utmContent = searchParams.get("utm_content");

  return { utmCampaign, utmSource, utmMedium, utmTerm, utmContent };
}

// Store URL parameters in LocalStorage
function storeParametersInLocalStorage() {
  const { utmCampaign, utmSource, utmMedium, utmTerm, utmContent } =
    getUrlParameters();

  if (utmCampaign) sessionStorage.setItem("utm_campaign", utmCampaign);
  if (utmSource) sessionStorage.setItem("utm_source", utmSource);
  if (utmMedium) sessionStorage.setItem("utm_medium", utmMedium);
  if (utmTerm) sessionStorage.setItem("utm_term", utmTerm);
  if (utmContent) sessionStorage.setItem("utm_content", utmContent);

  if (utmCampaign || utmSource || utmMedium || utmTerm || utmContent) {
    storeUtmParams(utmCampaign, utmSource, utmMedium, utmTerm, utmContent);
  }
}

// Store UTM parameters on the backend
function storeUtmParams(
  utmCampaign,
  utmSource,
  utmMedium,
  utmTerm,
  utmContent
) {
  const ajaxData = (window as any).njamito_ajax;

  if ((window as any).njamito_ajax) {
    let data = new FormData();
    data.append("action", "njamito_store_utm_params");
    data.append("utmCampaign", utmCampaign);
    data.append("utmSource", utmSource);
    data.append("utmMedium", utmMedium);
    data.append("utmTerm", utmTerm);
    data.append("utmContent", utmContent);
    data.append("nonce", ajaxData.nonce);

    fetch(ajaxData.ajax_url, {
      method: "POST",
      body: data,
    })
      .then((response) => {
        return response.json();
      })
      .then((jsonResponse) => {
        if (!jsonResponse.success) {
        }

        if (jsonResponse.success) {
        }
      });
  }
}

// Run storeParametersInLocalStorage on full page load
window.onload = function () {
  storeParametersInLocalStorage();
};
